import BaseCanvasModel from '@src/slide/application/service/canvas-component/core/base/base-canvas-model';
import { IPcCanvasProps, IPcCanvasState } from '@src/slide/application/service/canvas-component/core/pc/type';

export default class PcCanvasModel extends BaseCanvasModel<IPcCanvasProps> implements IPcCanvasState {
    public curCanvasWrapperStyle: any;
    public isMasterEditType = false;

    public initModel(props?: IPcCanvasProps, initObj?: Partial<this>) {
        super.initModel(props, initObj);

        const { curCanvasWrapperStyle } = initObj || { };
        this.curCanvasWrapperStyle = curCanvasWrapperStyle;
    }
}
